{
  "sdk-download-android": "Télécharger pour Android",
  "sdk-connect": "Se connecter",
  "sdk-download-ios": "Télécharger pour iOS",
  "sdk-install": "Installer",
  "sdk-modal-instruct-1": "1. Ouvrez l’application de Binance",
  "sdk-modal-instruct-2": "2. Appuyez sur {{icon}} sur l’écran d’accueil",
  "sdk-modal-title": "Se connecter à Binance",
  "sdk-no-app": "Vous n’avez pas encore l’application de Binance ?"
}